/* eslint-disable import/prefer-default-export */
export const getFileType = (file: File): 'image' | 'web' | 'file' => {
  const mimeType = file.type
  if (mimeType.startsWith('image/')) {
    return 'image'
  }
  if (mimeType === 'text/html' || mimeType === 'application/xhtml+xml') {
    return 'web'
  }
  return 'file'
}

export const downloadFile = async (fileUrl: string): Promise<void> => {
  const response = await fetch(`${fileUrl}?t=${Date.now()}`)
  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  const filename = fileUrl.split('/').pop() || 'report.pdf'
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const downloadFileFromWsUrl = (
  ws_url: string,
  token: string,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const wsUrl = `${ws_url}&authorization=${token}`
    const socket = new WebSocket(wsUrl)
    socket.onmessage = async (event) => {
      try {
        const data = JSON.parse(event.data)
        await downloadFile(data.pdf_urls[0])
        resolve()
      } catch (error) {
        reject(error)
      } finally {
        socket.close()
      }
    }
    socket.onerror = (error) => {
      reject(error)
      socket.close()
    }
  })
}

export const formatBytes = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
